import graphqlClient from "../../../apollo";

class SurveysProvider {

    findSurvey(id) {
        return graphqlClient.query({
            query: require('./gql/Surveys/findSurvey.graphql'),
            variables: {id:id},
            fetchPolicy: "network-only"
        })
    }

    fetchSurvey() {
        return graphqlClient.query({
        query: require('./gql/Surveys/fetchSurvey.graphql'),
        fetchPolicy: "network-only"
        })
    }
    
    paginateSurvey(pageNumber, itemsPerPage, search = null, filters = null,  orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/Surveys/paginateSurvey.graphql'),
            variables: {pageNumber, itemsPerPage, search, filters, orderBy, orderDesc},
            fetchPolicy: "network-only"
        })
    }

    createSurvey(input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Surveys/createSurvey.graphql'),
            variables: {input}
        })
    }
    
    updateSurvey(id,input) {
        return graphqlClient.mutate({
            mutation: require('./gql/Surveys/updateSurvey.graphql'),
            variables: {id, input}
        })
    }
    
    deleteSurvey(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/Surveys/deleteSurvey.graphql'),
            variables: {id}
        })
    }

}

export default new SurveysProvider()


